import { AuthManager } from "features/Authentication/AuthManager"
import { addDoc, collection } from "firebase/firestore"
import { db } from "firebaseInit"

type Data = {
  url: string
  body: any
  method: "GET" | "POST" | "PUT"
}

export const logOnFirebase = async (data: Data) => {
  try {
    const COLLECTION_NAME = "ito2023Logs"

    const additionalData = {
      user: AuthManager.getPlatformAuth()?.user.uuid,
      timestamp: new Date().toISOString(),
    }
    data = {
      ...additionalData,
      ...data,
    }
    // console.log("Logging", data)
    addDoc(collection(db, COLLECTION_NAME), data)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return
  }
}
